import { render } from "./OmaControls.vue?vue&type=template&id=fd019740&scoped=true"
import script from "./OmaControls.vue?vue&type=script&lang=js"
export * from "./OmaControls.vue?vue&type=script&lang=js"

import "./OmaControls.vue?vue&type=style&index=0&id=fd019740&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd019740"]])

export default __exports__